import React from 'react';
import cn from 'classnames';
import StatusDumbView from '../../../DeviationViews/Dumbo/Status';
import { Props } from '../InlineView';

import s from './Status.scss';

const StatusInlineView: React.FC<Props> = props => {
  const { deviation, width, height } = props;

  return (
    <div className={cn(s['root'])} style={{ width }}>
      <StatusDumbView width={width} height={height} deviation={deviation} />
    </div>
  );
};
StatusInlineView.displayName = 'StatusInlineView';

export default StatusInlineView;
